const POST = 'POST';
const GET = 'GET';

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(new Error(response.statusText));
  }
};

const getJsonHeaders = (headers = {}) => ({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    ...headers,
  },
  credentials: 'same-origin',
});

const getMethod = (methodValue) => {
  return {
    method: methodValue,
  };
};

const getBody = (requestParams) => {
  return {
    body: JSON.stringify(requestParams),
  };
};

const request = (url, params) =>
  fetch(url, params)
    .then(checkStatus)
    .then((response) => response.json().catch(() => {}));

const get = (url, headers = {}) => {
  const getParams = { ...getMethod(GET), ...getJsonHeaders(headers) };

  return request(url, getParams);
};

const post = (url, params, headers = {}) => {
  const postParams = {
    ...getMethod(POST),
    ...getBody(params),
    ...getJsonHeaders(headers),
  };

  return request(url, postParams);
};

export { get, post };
